<div class="page-container">
    <div class="page-header">
        <div class="header-info">
            <div class="header-title">Add Case Details</div>
        </div>
    </div>

    <div class="card" [appDynamicHeight]="24">
        <form [formGroup]="detailsForm" class="form-case">
            <!-- Section: Pre-filled Information (Non-editable) -->
            <div class="form-section">
                <div class="form-section-title">
                    Case Summary (Phase I)
                    <div class="section-description">
                        Information carried over from the preliminary submission.
                    </div>
                </div>
                <div class="form-section-content">
                    <div class="form-grid cols-2">
                        <div class="form-group">
                            <label>Attorney Name</label>
                            <div class="read-only-box">{{ prefilledData.attorney_name }}</div>
                        </div>
                        <div class="form-group">
                            <label>Firm Name</label>
                            <div class="read-only-box">{{ prefilledData.firm_name }}</div>
                        </div>
                        <div class="form-group">
                            <label>Attorney Email</label>
                            <div class="read-only-box">{{ prefilledData.attorney_email }}</div>
                        </div>
                        <div class="form-group">
                            <label>Attorney Phone</label>
                            <div class="read-only-box">{{ prefilledData.attorney_phone }}</div>
                        </div>
                        <div class="form-group">
                            <label>Patient Name</label>
                            <div class="read-only-box">{{ prefilledData.client_name }}</div>
                        </div>
                        <div class="form-group">
                            <label>Basic Case Type</label>
                            <div class="read-only-box">{{ prefilledData.basic_case_type }}</div>
                        </div>
                    </div>
                    <div class="form-group full-width">
                        <label>Preliminary Lien Summary</label>
                        <div class="read-only-box multiline">{{ prefilledData.lien_details }}</div>
                    </div>
                </div>
            </div>

            <!-- Section: Additional Patient Information -->
            <div class="form-section">
                <div class="form-section-title">
                    Patient Details
                    <div class="section-description">
                        Provide additional required patient information.
                    </div>
                </div>
                <div class="form-section-content">
                    <div class="form-grid cols-2">
                        <div class="form-group">
                            <label for="client_dob">Date of Birth</label>
                            <app-date-picker
                                [showLabel]="false"
                                formControlName="client_dob"
                                placeholder="Select DOB"
                                [maxDate]="today">
                            </app-date-picker>
                            @if (getErrorMessage('client_dob', 'Date of Birth')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('client_dob', 'Date of Birth') }}
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label for="last_four_ssn">Last Four Digits of Social Security Number</label>
                            <input type="text" id="last_four_ssn" formControlName="last_four_ssn" placeholder="0000" maxlength="4">
                            @if (getErrorMessage('last_four_ssn', 'Last Four SSN')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('last_four_ssn', 'Last Four SSN') }}
                                </div>
                            }
                        </div>
                    </div>
                    <div class="form-grid cols-2">
                        <div class="form-group">
                            <label for="client_contact">Phone Number</label>
                            <input appPhoneFormat id="client_contact" formControlName="client_contact" placeholder="(555) 000-0000">
                            @if (getErrorMessage('client_contact', 'Phone')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('client_contact', 'Phone') }}
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label for="client_email">Email Address</label>
                            <input type="email" id="client_email" formControlName="client_email" placeholder="patient@example.com">
                            @if (getErrorMessage('client_email', 'Email')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('client_email', 'Email') }}
                                </div>
                            }
                        </div>
                    </div>
                    <div class="form-grid cols-1">
                        <div class="form-group">
                            <label for="patient_address">Patient Address</label>
                            <input type="text" id="patient_address" formControlName="patient_address" placeholder="Enter patient address...">
                            @if (getErrorMessage('patient_address', 'Patient Address')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('patient_address', 'Patient Address') }}
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <div class="same-address-toggle">
                                <label>Posting address is same as patient address</label>
                                <label class="toggle-switch">
                                    <input type="checkbox" formControlName="same_address"
                                        [checked]="detailsForm.get('same_address')?.value"
                                        (change)="onSameAddressToggle()">
                                    <span class="toggle-slider"></span>
                                </label>
                            </div>
                        </div>
                        @if (!detailsForm.get('same_address')?.value) {
                        <div class="form-group">
                            <label for="posting_address">Posting Address</label>
                            <input type="text" id="posting_address" formControlName="posting_address" placeholder="Enter posting address...">
                        </div>
                        }
                    </div>
                </div>
            </div>

            <!-- Section: Detailed Lien Information -->
            <div class="form-section">
                <div class="form-section-title">
                    Lien Details
                    <div class="section-description">
                        Provide the latest details regarding the lien holder and balance.
                    </div>
                </div>
                <div class="form-section-content">
                    <div class="form-grid">
                        <div class="form-group">
                            <label for="hospital_name">Hospital / Lien Holder Name</label>
                            <input type="text" id="hospital_name" formControlName="hospital_name" placeholder="Enter name...">
                            @if (getErrorMessage('hospital_name', 'Hospital Name')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('hospital_name', 'Hospital Name') }}
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label for="hospital_account_number">Hospital Account Number</label>
                            <input type="text" id="hospital_account_number" formControlName="hospital_account_number" placeholder="Enter account number...">
                            @if (getErrorMessage('hospital_account_number', 'Hospital Account Number')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('hospital_account_number', 'Hospital Account Number') }}
                                </div>
                            }
                        </div>
                    </div>
                    <div class="form-grid">
                        <div class="form-group">
                            <label for="date_of_service">Date of Service (Admission Date)</label>
                            <app-date-picker
                                [showLabel]="false"
                                formControlName="date_of_service"
                                placeholder="Select date"
                                [maxDate]="today">
                            </app-date-picker>
                            @if (getErrorMessage('date_of_service', 'Date of Service')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('date_of_service', 'Date of Service') }}
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label for="current_lien_balance">Current Lien Balance ($)</label>
                            <input appAmountFormat id="current_lien_balance" formControlName="current_lien_balance" placeholder="0.00">
                            @if (getErrorMessage('current_lien_balance', 'Balance')) {
                                <div class="error-msg">
                                    {{ getErrorMessage('current_lien_balance', 'Balance') }}
                                </div>
                            }
                        </div>
                    </div>

                    <div class="form-group full-width">
                        <label for="supporting_details">Supporting Details (Status of treatment, billing, etc.)</label>
                        <textarea id="supporting_details" formControlName="supporting_details" rows="4" placeholder="Describe the current status..."></textarea>
                    </div>

                    <div class="form-grid">
                        <div class="form-group">
                            <label>Reductions already requested/offered?</label>
                            <div class="radio-group">
                                <label class="radio-option">
                                    <input type="radio" formControlName="reductions_requested" [value]="true" />
                                    <span class="radio-label">Yes</span>
                                </label>
                                <label class="radio-option">
                                    <input type="radio" formControlName="reductions_requested" [value]="false" />
                                    <span class="radio-label">No</span>
                                </label>
                            </div>
                        </div>
                        @if (detailsForm.get('reductions_requested')?.value === true) {
                            <div class="form-group">
                                <label for="reduction_amount">Reduction Amount ($)</label>
                                <input appAmountFormat id="reduction_amount" formControlName="reduction_amount" placeholder="0.00">
                                @if (getErrorMessage('reduction_amount', 'Reduction Amount')) {
                                    <div class="error-msg">
                                        {{ getErrorMessage('reduction_amount', 'Reduction Amount') }}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>

            <!-- Section: Document Uploads -->
            <div class="form-section">
                <div class="form-section-title">
                    Required Documents
                    <div class="section-description">
                        Upload the necessary files for case verification.
                    </div>
                </div>
                <div class="form-section-content">
                    <!-- Partial Closing Statement -->
                    <div class="document-question">
                        <div class="form-group">
                            <label>Can you provide a Partial Closing Statement or other document showing all medicals?</label>
                            <div class="radio-group">
                                <label class="radio-option">
                                    <input type="radio" formControlName="has_partial_closing_statement" [value]="true" />
                                    <span class="radio-label">Yes</span>
                                </label>
                                <label class="radio-option">
                                    <input type="radio" formControlName="has_partial_closing_statement" [value]="false" />
                                    <span class="radio-label">No</span>
                                </label>
                            </div>
                        </div>
                        @if (detailsForm.get('has_partial_closing_statement')?.value === true) {
                            <app-file-upload label="Upload Partial Closing Statement" formControlName="partial_closing_statement"
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                [multiple]="true"
                                [hasError]="!!getErrorMessage('partial_closing_statement', 'Partial Closing Statement')">
                            </app-file-upload>
                        }
                        @if (detailsForm.get('has_partial_closing_statement')?.value === false) {
                            <div class="form-group">
                                <label for="no_partial_closing_reason">Please explain why not</label>
                                <textarea id="no_partial_closing_reason" formControlName="no_partial_closing_reason" rows="3" placeholder="Explain why this document is not available..."></textarea>
                                @if (getErrorMessage('no_partial_closing_reason', 'Explanation')) {
                                    <div class="error-msg">
                                        {{ getErrorMessage('no_partial_closing_reason', 'Explanation') }}
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    <!-- Itemized Bill or Invoice -->
                    <div class="document-question">
                        <div class="form-group">
                            <label>Can you provide an Itemized Bill or Invoice from the hospital?</label>
                            <div class="radio-group">
                                <label class="radio-option">
                                    <input type="radio" formControlName="has_itemized_bill" [value]="true" />
                                    <span class="radio-label">Yes</span>
                                </label>
                                <label class="radio-option">
                                    <input type="radio" formControlName="has_itemized_bill" [value]="false" />
                                    <span class="radio-label">No</span>
                                </label>
                            </div>
                        </div>
                        @if (detailsForm.get('has_itemized_bill')?.value === true) {
                            <app-file-upload label="Upload Itemized Bill or Invoice" formControlName="itemized_bill"
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                [multiple]="true"
                                [hasError]="!!getErrorMessage('itemized_bill', 'Itemized Bill')">
                            </app-file-upload>
                        }
                        @if (detailsForm.get('has_itemized_bill')?.value === false) {
                            <div class="form-group">
                                <label for="no_itemized_bill_reason">Please explain why not</label>
                                <textarea id="no_itemized_bill_reason" formControlName="no_itemized_bill_reason" rows="3" placeholder="Explain why this document is not available..."></textarea>
                                @if (getErrorMessage('no_itemized_bill_reason', 'Explanation')) {
                                    <div class="error-msg">
                                        {{ getErrorMessage('no_itemized_bill_reason', 'Explanation') }}
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    <!-- Hospital Claim of Lien -->
                    <div class="document-question">
                        <div class="form-group">
                            <label>Can you provide a statutory Hospital Claim of Lien or copy of Contractual Lien?</label>
                            <div class="radio-group">
                                <label class="radio-option">
                                    <input type="radio" formControlName="has_hospital_claim_lien" [value]="true" />
                                    <span class="radio-label">Yes</span>
                                </label>
                                <label class="radio-option">
                                    <input type="radio" formControlName="has_hospital_claim_lien" [value]="false" />
                                    <span class="radio-label">No</span>
                                </label>
                            </div>
                        </div>
                        @if (detailsForm.get('has_hospital_claim_lien')?.value === true) {
                            <app-file-upload label="Upload Hospital Claim of Lien" formControlName="hospital_claim_lien"
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                [multiple]="true"
                                [hasError]="!!getErrorMessage('hospital_claim_lien', 'Hospital Claim of Lien')">
                            </app-file-upload>
                        }
                        @if (detailsForm.get('has_hospital_claim_lien')?.value === false) {
                            <div class="form-group">
                                <label for="no_hospital_claim_reason">Please explain why not</label>
                                <textarea id="no_hospital_claim_reason" formControlName="no_hospital_claim_reason" rows="3" placeholder="Explain why this document is not available..."></textarea>
                                @if (getErrorMessage('no_hospital_claim_reason', 'Explanation')) {
                                    <div class="error-msg">
                                        {{ getErrorMessage('no_hospital_claim_reason', 'Explanation') }}
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    <!-- Correspondence with Hospital -->
                    <div class="document-question">
                        <div class="form-group">
                            <label>Can you provide copies of all correspondence to date, with Hospital?</label>
                            <div class="radio-group">
                                <label class="radio-option">
                                    <input type="radio" formControlName="has_correspondence" [value]="true" />
                                    <span class="radio-label">Yes</span>
                                </label>
                                <label class="radio-option">
                                    <input type="radio" formControlName="has_correspondence" [value]="false" />
                                    <span class="radio-label">No</span>
                                </label>
                            </div>
                        </div>
                        @if (detailsForm.get('has_correspondence')?.value === true) {
                            <app-file-upload label="Upload Correspondence" formControlName="correspondence"
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                [multiple]="true"
                                [hasError]="!!getErrorMessage('correspondence', 'Correspondence')">
                            </app-file-upload>
                        }
                        @if (detailsForm.get('has_correspondence')?.value === false) {
                            <div class="form-group">
                                <label for="no_correspondence_reason">Please explain why not</label>
                                <textarea id="no_correspondence_reason" formControlName="no_correspondence_reason" rows="3" placeholder="Explain why this document is not available..."></textarea>
                                @if (getErrorMessage('no_correspondence_reason', 'Explanation')) {
                                    <div class="error-msg">
                                        {{ getErrorMessage('no_correspondence_reason', 'Explanation') }}
                                    </div>
                                }
                            </div>
                        }
                    </div>

                    <div class="form-actions align-left">
                        <button type="button" class="btn btn-md btn-primary" (click)="handleSave()">Submit Case Details</button>
                        <button type="button" class="btn btn-md btn-default" (click)="handleCancel()">Cancel</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>